import { FilterIcon } from "@heroicons/react/outline";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "~/design-system/Box";
import { Button } from "~/design-system/Button";
import { Dialog, DialogContent } from "~/design-system/Dialog";
import { Stack } from "~/design-system/Stack";
import { createComponentHook } from "~/types";
import type { NotificationsFilterContentProps } from "./components/NotificationsFilterContent";
import { NotificationsFilterContent } from "./components/NotificationsFilterContent";

type NotificationsFilterDialogProps = NotificationsFilterContentProps & {
  children: React.ReactNode;
};

const useNotificationsFilterDialog = createComponentHook(() => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);

  return {
    actions: {
      setOpen,
    },
    state: {
      open,
    },
    t,
  };
});

const NotificationsFilterDialog = (props: NotificationsFilterDialogProps) => {
  const { actions, state, t } = useNotificationsFilterDialog();

  return (
    <Dialog open={state.open} setOpen={actions.setOpen}>
      {props.children}
      <DialogContent width="small" stopClickPropagation size="full">
        <Box
          background="card"
          width="full"
          css={{
            height: "100%",
            overflowY: "auto",
            padding: "$gutter",
          }}
        >
          <Stack space="gutter">
            <NotificationsFilterContent
              inDialog
              filters={props.filters}
              setFilters={props.setFilters}
            />
            <Button
              leadingIcon={<FilterIcon />}
              size="large"
              width="full"
              onClick={() => actions.setOpen(false)}
              type="button"
              dataClovisActionId="user-notifications-filter-submit"
            >
              {t(
                "screens.UserNotificationsScreen.NotificationsFilterDialog.submitButton",
                "Filter"
              )}
            </Button>
          </Stack>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export { NotificationsFilterDialog };
